const endpoints = {
  auth: {
    login: "/auth/login",
  },

  dashboard: {
    base: "/dashboard",
    searchGuest: "/dashboard/search-guest",
  },

  lot: {
    base: "/lot",
    store: "/lot/store",
    options: "/lot/options",
    selectionData: "/lot/selection-data",
    detail: (id) => `/lot/${id}`,
    deletePhoto: (id, photo) => `/lot/${id}/photos/${encodeURIComponent(photo)}`,
  },

  addOn: {
    base: "/add-on",
    detail: (id) => `/add-on/${id}`,
    bulkAssignLots: (id) =>
      `/add-on/${id}/bulk-assign-lots`,
  },

  promotion: {
    base: "/promotion",
    selectionData: "/promotion/selection-data",
    detail: (id) => `/promotion/${id}`,
  },

  package: {
    base: "/package",
    detail: (id) => `/package/${id}`,
  },

  user: {
    base: "/user",
    detail: (id) => `/user/${id}`,
    changePassword: (id) =>
      `/user/${id}/change-password`,
  },

  log: {
    base: "/log",
  },

  reservation: {
    base: "/reservations",
    detail: (id) => `/reservations/${id}`,
    masterData: "/reservations/master-data",
    resendConfirmation: (id) => `/reservations/${id}/resend-confirmation`,
    cancel: (id) => `/reservations/${id}/cancel`
  },

  accessPermit: {
    base: "/access-permit",
    generate: (reservationId) =>
      `/access-permit/${reservationId}/generate`,
    sendEmail: (reservationId) =>
      `/access-permit/${reservationId}/email`,
  },

  settings: {
    base: "/setting",
    upload: "/setting/upload",
    deleteReceiptLogo:
      "/setting/receipt/logo",
  },

  page: {
    base: "/page",
    detail: (pageKey) => `/page/${pageKey}`,
    upload: "/page/upload-image",
  },

  transactions: {
    base: "/transactions",
    detail: (id) => `/transactions/${id}`,
  },

  receipts: {
    base: "/receipts",
    detail: (id) => `/receipts/${id}`,
    sendEmail: (id) =>
      `/receipts/${id}/send-email`,
  },

  report: {
    base: "/report",

    roster: "/report/roster",
    reservations: "/report/reservations",
    slips: "/report/slips",
    transactions: "/report/transactions",
    receipts: "/report/receipts",

    receiptsBatch: "/report/receipts/batch",

    detail: (id) => `/report/${id}`,
  },
};

export default endpoints;